import React, { useEffect } from 'react'
import PropTypes from 'prop-types'

import { useLocalization } from '@contexts/LocalizationContext'
import { Button, Col, DatePicker, Form, Input, InputNumber, Row } from 'antd'
// import dayjs from 'dayjs'

const FormComponent = ({
  handleSubmit,
  defaultValues = { posterImages: [] },
  isEdit = false,
}) => {
  const [form] = Form.useForm()

  const { t } = useLocalization()

  const tailLayout = {
    wrapperCol: {
      span: 20,
      offset: 2,
    },
  }

  const style = {
    inputShop: { width: '100%', height: '40px' },
    inputDateForm: { width: '100%', height: '40px' },

    btnStyleSummit: {
      height: '37px',
      width: '176px',
      borderRadius: '8px',
      border: '1px solid #56B9C3',
    },

    btnStyleSummitAdd: {
      // height: '37px',
      width: '232px',
      borderRadius: '8px',
      border: '1px solid #56B9C3',
    },
  }

  useEffect(() => {
    form.resetFields()
  }, [defaultValues])

  const { RangePicker } = DatePicker
  // const disabledDate = (current) => {
  //   return current && current < dayjs().endOf('day').add(-1, 'day')
  // }

  return (
    <Form
      layout="vertical"
      form={form}
      name="control-hooks"
      onFinish={handleSubmit}
      initialValues={defaultValues}
      requiredMark={false}
    >
      <div hidden>
        <Form.Item name="id">
          <Input />
        </Form.Item>
      </div>

      <Form.Item
        name="code"
        label="รหัสส่วนลด"
        defaultValue={defaultValues.code || ''}
        rules={[
          {
            required: true,
            message: 'กรุณากรอกรหัสส่วนลด',
          },
        ]}
      >
        <Input style={style.inputShop} />
      </Form.Item>

      <Form.Item
        name="amount"
        defaultValue={defaultValues.amount || ''}
        label="จำนวนที่ใช้ได้"
        rules={[
          {
            required: true,
            message: 'กรุณากรอกจำนวนที่ใช้ได้',
          },
        ]}
      >
        <InputNumber style={style.inputShop} />
      </Form.Item>

      <Form.Item
        name="discount"
        defaultValue={defaultValues.discount || ''}
        label="ส่วนลด (บาท)"
        rules={[
          {
            required: true,
            message: 'กรุณากรอกส่วนลด',
          },
        ]}
      >
        <InputNumber style={style.inputShop} />
      </Form.Item>

      <Row style={{ alignItems: 'center', width: '100%' }}>
        <Row style={{ width: '100%', padding: '0px 0px 8px' }}>
          <Col span={12}>ระยะเวลาเริ่มต้น</Col>
          <Col span={12}>ระยะเวลาสิ้นสุด</Col>
        </Row>
        <Form.Item
          style={{ width: '100%' }}
          name="usableSinceToUntil"
          rules={[
            {
              required: true,
              message: 'กรุณาเลือกระยะเวลา',
            },
          ]}
        >
          <RangePicker
            style={style.inputDateForm}
            // disabledDate={disabledDate}
            format="YYYY-MM-DD"
          />
        </Form.Item>
      </Row>

      <Form.Item
        name="description"
        defaultValue={defaultValues.description || ''}
        label={'รายละเอียด'}
        rules={[
          {
            required: true,
            message: t('campaign.form.error.description'),
          },
        ]}
      >
        <Input.TextArea style={{ ...style.inputShop, minHeight: 100 }} />
      </Form.Item>

      {/* เเสดงปุ่ม */}
      <Form.Item {...tailLayout}>
        <div style={{ textAlign: 'center' }}>
          <Button
            type="primary"
            htmlType="submit"
            style={style.btnStyleSummitAdd}
          >
            {isEdit ? 'แก้ไข' : t('discountCode.form.addData')}
          </Button>
        </div>
      </Form.Item>
    </Form>
  )
}
FormComponent.propTypes = {
  doStatus: PropTypes.string,
  handleSubmit: PropTypes.func,
  defaultValues: PropTypes.object,
  isEdit: PropTypes.bool,
}

export default FormComponent
